import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import DocumentModal from "../Client-Info/DocumentModel";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/plugins/monthSelect/style.css";
import ServiceTaskComments from "../Services/ServiceTaskComments";
export default function ClientDashboard() {
  const [filterValues, setFilterValues] = useState({
    month: new Date(),
  });
  const [lists, setLists] = useState([]);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [errors, setErrors] = useState({});
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [data, setData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [documentModalVisible, setDocumentModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});
  const [currentServiceTask, setCurrentServiceTask] = useState(null);
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [currentTaskForComments, setCurrentTaskForComments] = useState(null);
  const clientId = localStorage.getItem("clientId");
  const userId = localStorage.getItem("userId");
  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setFilterValues({
        ...recordForEdit,
        clientId: clientId,
      });
    }
  }, [recordForEdit]);
  const resetForm = () => {
    setFilterValues({
      month: new Date(),
    });
    setErrors({});
  };
  const handleReset = () => {
    resetForm();
    GetData(1);
  };
  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    GetData(1);
  };
  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };
  const toggleDocumentModal = (serviceTask) => {
    setCurrentServiceTask(serviceTask);
    setDocumentModalVisible(!documentModalVisible);
  };

  const toggleCommentsModal = (serviceTask) => {
    setCurrentTaskForComments(serviceTask);
    setShowCommentsModal(!showCommentsModal);
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETTASKACCEPTEDBYSTAFF +
          "?userId=" +
          userId +
          "&clientId=" +
          clientId +
          "&month=" +
          moment(filterValues.month).format("YYYY-MM") +
          "&pageNumber=" +
          number +
          "&pageSize=" +
          pageSize,

        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }
  const handlePayment = async (e, serviceTask) => {
    e.preventDefault();
    setLoadingStates((prev) => ({
      ...prev,
      [serviceTask.serviceTaskId]: true,
    }));

    try {
      await displayRazorpay(serviceTask);
    } catch (error) {
      console.error("Payment error:", error);
    }
    setLoadingStates((prev) => ({
      ...prev,
      [serviceTask.serviceTaskId]: false,
    }));
  };
  async function displayRazorpay(serviceTask) {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }
    const result = await axios.post(
      config.APIACTIVATEURL +
        config.PAYMENTORDERREQUEST +
        "?Amount=" +
        Math.round(parseFloat(serviceTask.amount)) +
        "&PayRequest=RAZORPAY"
    );
    if (!result) {
      alert("Server error. Are you online?");
      return;
    }
    if (result.data.statusCode == 200) {
      const {
        amount,
        id: order_id,
        currency,
        razorpayKey,
        name,
      } = result.data.response;
      const options = {
        key: razorpayKey,
        amount: amount,
        currency: currency,
        name: name,
        description: "Service Payment",
        order_id: order_id,
        handler: async function (response) {
          await UpdateServiceTask(response.razorpay_payment_id, serviceTask);
        },
        prefill: {
          name: serviceTask.clientName,
          email: "client@example.com",
          contact: "9123456789",
        },
        notes: {
          address: "Hyderabad",
        },
        theme: { color: "#FDE047" },
        modal: {
          ondismiss: function () {
            setLoading(false);
          },
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } else {
      alert("Payment failed. Please try again");
    }
  }
  const UpdateServiceTask = (RazorKey, serviceTask) => {
    const paymentData = {
      serviceTaskId: serviceTask.serviceTaskId,
      amount: serviceTask.amount,
      paymentMethod: "RAZORPAY",
      razorpayPaymentId: RazorKey,
    };
    axios
      .put(config.APIACTIVATEURL + config.UPDATEPAYMENT, paymentData, {
        ...headerconfig,
      })
      .then((res) => {
        handleSuccess("Payment done successfully!");
        setLoading(false);
        GetData(pageNumber);
      })
      .catch((error) => {
        handleError("Failed to pay.");
        console.error(error);
        setLoading(false);
      });
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    GetData(pageNumber);
  }, []);

  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSideBar></LayoutSideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Dashboard</h4>
                </div>
              </div>
            </div>
            <div className="row mb-3 pb-1">
              <div className="col-12">
                <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                  <div className="flex-grow-1">
                    <h4 className="fs-16 mb-1">
                      Good Morning{" "}
                      <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                        {localStorage.getItem("name")}
                      </span>
                    </h4>
                    <p className="text-muted mb-0">
                      Here's what's happening today.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label>Month</label>
                      <div className="input-group">
                        <Flatpickr
                          value={filterValues.month}
                          className={"form-select " + applyErrorClass("month")}
                          options={{
                            dateFormat: "Y-m",
                            plugins: [
                              new (require("flatpickr/dist/plugins/monthSelect"))(
                                {
                                  shorthand: true,
                                  dateFormat: "M-Y",
                                  theme: "light",
                                }
                              ),
                            ],
                          }}
                          onChange={(date) =>
                            setFilterValues({ ...filterValues, month: date[0] })
                          }
                        />
                        <div className="input-group-text bg-primary border-primary text-white">
                          <i className="ri-calendar-2-line" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="hstack gap-2 justify-content-middle mb-3 mt-4">
                      <button type="submit" className="btn btn-primary w-100">
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger w-100 ml-2"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>Staff</th>
                            <th>Service</th>
                            <th>Month</th>
                            <th>Cycle</th>
                            <th>Service Status</th>
                            <th>LastUpdated Date</th>
                            <th>Upload Documents</th>
                            <th>Amount</th>
                            <th>Payment Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {lists && lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.serviceTaskId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>
                                <td>{v.staffName}</td>
                                <td>{v.serviceName}</td>
                                <td>{moment(v.month).format("MMM-YYYY")}</td>
                                <td>{v.cycle}</td>
                                <td>
                                  <span
                                    className={
                                      "badge " +
                                      (v.status === "COMPLETED"
                                        ? "bg-success"
                                        : "bg-warning")
                                    }
                                  >
                                    {v.status}
                                  </span>
                                </td>
                                <td>
                                  {moment(v.lastUpdatedDate).format(
                                    "DD MMM YY hh:mm a"
                                  )}
                                </td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li onClick={() => toggleDocumentModal(v)}>
                                      <i className="fas fa-file-alt"></i>
                                    </li>
                                  </ul>
                                </td>
                                <td>{v.amount}</td>
                                <td>
                                  <span
                                    className={
                                      "badge " +
                                      (v.paymentStatus === "Success"
                                        ? "bg-success"
                                        : "bg-warning")
                                    }
                                  >
                                    {v.paymentStatus}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center gap-2">
                                    {v.paymentStatus === "Success" ? (
                                      <button
                                        className="btn btn-success btn-sm"
                                        disabled
                                      >
                                        Paid
                                      </button>
                                    ) : (
                                      <button
                                        className="btn btn-primary btn-sm"
                                        onClick={(e) => handlePayment(e, v)}
                                        disabled={
                                          loadingStates[v.serviceTaskId] ||
                                          !v.amount ||
                                          parseFloat(v.amount) <= 0
                                        }
                                      >
                                        {loadingStates[v.serviceTaskId]
                                          ? "Processing..."
                                          : "Pay"}
                                      </button>
                                    )}

                                    <Link
                                      className="text-secondary"
                                      onClick={() => toggleCommentsModal(v)}
                                    >
                                      <i className="ri-chat-3-fill fs-16" />
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center">
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={
                            "page-item " + (pageNumber === 1 ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber - 1)}
                        >
                          <Link className="page-link">Previous</Link>
                        </li>
                        {renderPageNumbers}
                        <li
                          className={
                            "page-item " +
                            (pageNumber === totalPages ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber + 1)}
                        >
                          <Link className="page-link">Next</Link>
                        </li>
                      </ul>
                    </div>
                    {documentModalVisible && (
                      <DocumentModal
                        currentServiceTask={currentServiceTask}
                        setDocumentModalVisible={setDocumentModalVisible}
                        pageNumber={1}
                        headerconfig={headerconfig}
                      />
                    )}
                    {showCommentsModal && (
                      <ServiceTaskComments
                        serviceTaskId={currentTaskForComments?.serviceTaskId}
                        onClose={() => setShowCommentsModal(false)}
                        headerconfig={headerconfig}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
